var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJdLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 225,
    viewBox: "0 0 240 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_5",
    "data-name": "\\u7EC4 5",
    transform: "translate(-1850.147 -387.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_1",
    "data-name": "\\u7EC4 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_1",
    "data-name": "\\u8DEF\\u5F84 1",
    d: "M1863.962,612.166a1.387,1.387,0,0,0-.083-.417,5.482,5.482,0,0,0-.25-1.418c.555.054,1.084.083,1.584.083q1.251,0,1.167-.918V601.82h-3v-1.668h3.752c-.056-.055-.14-.138-.25-.251q-1.251-1.416-2.5-2.669l1.251-1,1.584,1.586,2.168-2.754H1863.8v-1.585h7.421V595.4l-2.835,3.671.416.334-.667.751h3.586v1.668l-.751,3.505c-.278-.055-.612-.111-1-.167a2.342,2.342,0,0,0-.5-.084l.75-3.254h-2v8.01q.083,2.253-2.251,2.336Zm18.511,0q-1.836-1.67-4.92-4.005-1.085,2-5.669,4.339-.5-.751-1.168-1.585,3.753-1.5,4.92-3.087,1.25-1.418,1.25-4.589V600.4h1.751v2.92a8.568,8.568,0,0,1-.417,3.254q2.835,2.086,5.42,4.088Zm-10.173-17.1v-1.668h11.257v1.668h-5l-.5,2.67h4.669v9.762h-1.751v-8.26h-6.42v8.343H1872.8v-9.845h3.418l.417-2.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_2",
    "data-name": "\\u8DEF\\u5F84 2",
    d: "M1908.738,611.666q-3,.081-2.919-2.754V604.24q-1.085,5.091-9.005,8.177a16.963,16.963,0,0,1-1.25-1.753q5.253-2,7-4.255,1.835-2.168,1.918-6.758l.084-2.837h2l-.167,3.087a15.864,15.864,0,0,1-.334,3.421h1.751v5.173a1.25,1.25,0,0,0,1.418,1.5h2.251q1.75,0,1.835-1.5a13.856,13.856,0,0,0,.333-2.336v-.25l1,.25q.666.25.917.334-.168,1.5-.417,2.753-.418,2.5-3.335,2.42Zm-10.673-5.841V593.477h14.925v11.931h-1.918v-10.1h-11.089v10.512Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_3",
    "data-name": "\\u8DEF\\u5F84 3",
    d: "M1945.508,611.749l-1.25-1.5a2.2,2.2,0,0,0,.667-1.752V600.9h5v-5.09h-5.253v-1.919h7.171v7.092a25.873,25.873,0,0,0,3.836-8.51l1.917.25q-.5,1.669-1,3.171h7.5v1.835h-1.834q-.669,6.092-3.169,9.428a13.1,13.1,0,0,0,5.17,3.254,15.8,15.8,0,0,0-.917,1.335,3.634,3.634,0,0,0-.334.5,21.537,21.537,0,0,1-5.169-3.671,26.672,26.672,0,0,1-5.92,3.921,11.4,11.4,0,0,0-1-1.5,2.56,2.56,0,0,0-.25-.334,17.082,17.082,0,0,0,5.92-3.587,17.493,17.493,0,0,1-2.335-6.258,22.608,22.608,0,0,1-1.25,1.919,10.737,10.737,0,0,0-1.168-1.585v1.585h-5v6.091q.832-.333,3-1.335,1.417-.666,2.085-.918a17.716,17.716,0,0,0,.166,2.086,57.084,57.084,0,0,0-5.253,2.253A5.36,5.36,0,0,0,1945.508,611.749Zm10.339-14.017-.083.167a1.2,1.2,0,0,1-.25.417,18.951,18.951,0,0,0,2.418,7.176,16.556,16.556,0,0,0,2.5-7.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4",
    "data-name": "\\u8DEF\\u5F84 4",
    d: "M1977.276,602.822a12.759,12.759,0,0,0-1.167-1.335,39.166,39.166,0,0,0,4-3.755l1.167,1.335A30.247,30.247,0,0,1,1977.276,602.822Zm17.927,9.428a30.5,30.5,0,0,1-9.089-2.253,39.056,39.056,0,0,1-8.921,2.5,10.382,10.382,0,0,0-1-1.836,30.019,30.019,0,0,0,8-1.752,18.047,18.047,0,0,1-3.918-4.255h-1.751v-1.668h14.091v1.752A16.145,16.145,0,0,1,1988.2,609a30.884,30.884,0,0,0,7.921,1.418Q1995.7,611.248,1995.2,612.25Zm-18.761-15.6V594.9h9.172a6.258,6.258,0,0,0-.417-1.168,9.237,9.237,0,0,0-.417-1.084l2.085-.251q.165.418.5,1.335a8.952,8.952,0,0,0,.417,1.085l-.25.083h8.338v1.753h-6.337v5.172H1987.7v-5.172h-3.085v5.172h-1.834v-5.172Zm13.841,8.009h-7.838a11.388,11.388,0,0,0,3.753,3.338A13.207,13.207,0,0,0,1990.283,604.657Zm4.5-1.752q-.836-.917-2.585-2.586-.918-.916-1.334-1.335l1.167-1.168q1.917,1.586,4.086,3.754Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_5",
    "data-name": "\\u8DEF\\u5F84 5",
    d: "M2024.969,606.576v-1.752h10.089a.743.743,0,0,0,.084-.334,19.616,19.616,0,0,0,.75-6.758h2.085a29.61,29.61,0,0,1-.751,6.842v.25h7.421v1.752h-8l-.334.668q4,1.752,8.005,3.254l-1,1.668q-3.5-1.67-8-3.421-2.086,2.336-9.256,3.755a14.128,14.128,0,0,0-.917-1.669c.111.167.055.055-.167-.333q8.086-1,9.422-3.922Zm.417-7.425V594.9h8.839c-.057-.11-.14-.3-.251-.584a15.383,15.383,0,0,0-.75-1.585l2.168-.334a12.316,12.316,0,0,1,.667,1.419,8.927,8.927,0,0,0,.417,1.084h7.671v4.256h-1.918v-2.5H2027.3v2.5Zm6.17,5.339a37.723,37.723,0,0,0-4.419-2.336l.917-1.418c.444.223.584.279.417.167q2.667,1.335,4.086,2Zm1.918-3.17q-2.251-1.251-4.252-2.253l.834-1.418q2.25,1,4.335,2.169Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_6",
    "data-name": "\\u8DEF\\u5F84 6",
    d: "M2056.9,595.813v-1.752h6.921v1.752h-2.585v5.09h2.334v1.752h-2.334v5.089q.416-.081,1.25-.167,1.083-.165,1.5-.25a11.952,11.952,0,0,0,.084,1.836q-2.5.418-7.171,1l-.25-1.752q.5-.082,1.834-.251a9.086,9.086,0,0,0,.917-.166v-5.34h-2.251V600.9h2.251v-5.09Zm15.425,16.02a2.176,2.176,0,0,1-2.5-2.42v-3.337q-1,3.171-6.17,6.341l-.667-.668c-.334-.39-.584-.667-.751-.834q4-2.169,5.253-4.255,1.334-1.918,1.5-6.091.083-1.5.084-3.838H2071q0,1.587-.166,3.421a22.113,22.113,0,0,1-.5,4.171h1.334v4.756c-.056.78.334,1.14,1.168,1.085h.667q1.25.082,1.417-1,.082-.5.167-1.752c0,.166.027-.055.083-.668a7.321,7.321,0,0,1,1.751.584,16.634,16.634,0,0,1-.25,2.253q.25-1.167-.083.25-.335,2.085-2.835,2Zm-7.837-6.091V593.394h10.922v12.181h-1.834V595.146h-7.171v10.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_1",
    "data-name": "\\u692D\\u5706 1",
    cx: 1.422,
    cy: 1.422,
    r: 1.422,
    transform: "translate(1928.495 600.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706_2",
    "data-name": "\\u692D\\u5706 2",
    cx: 1.422,
    cy: 1.422,
    r: 1.422,
    transform: "translate(2009.04 600.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_4",
    "data-name": "\\u7EC4 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_3",
    "data-name": "\\u7EC4 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_7",
    "data-name": "\\u8DEF\\u5F84 7",
    d: "M1957.348,543.568v-3.586h-12.389v-6.063h-3.743v6.063h-10.263a23.729,23.729,0,0,0,5.527-9.19h21.581v-3.585h-20.768a27.3,27.3,0,0,0,.28-3.942h-3.744a23.208,23.208,0,0,1-.325,3.942h-8.756v3.585h7.769a23.116,23.116,0,0,1-6.98,9.19h-.008v3.586h15.687v11.039a.509.509,0,0,1-.508.509h-5.667v3.746h5.667a4.258,4.258,0,0,0,4.251-4.255V543.568Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_8",
    "data-name": "\\u8DEF\\u5F84 8",
    d: "M1879.936,523.35v3.856h-15.108v3.585h33.951v-3.585h-15.1V523.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_9",
    "data-name": "\\u8DEF\\u5F84 9",
    d: "M1892.441,544.6h3.743v-11.66h-28.755V544.6h13.108V554.61a.511.511,0,0,1-.508.508h-5.669v3.746h5.669a4.26,4.26,0,0,0,4.251-4.254V544.6Zm-21.268-8.075h21.268v4.489h-21.268Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_10",
    "data-name": "\\u8DEF\\u5F84 10",
    d: "M1869.275,544.935h.246l-.219-.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_11",
    "data-name": "\\u8DEF\\u5F84 11",
    d: "M1864.638,557.708h3.984l4.027-11.1h-3.984Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_12",
    "data-name": "\\u8DEF\\u5F84 12",
    d: "M1894.232,544.935l-.027-.08-.219.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_13",
    "data-name": "\\u8DEF\\u5F84 13",
    d: "M1890.858,546.6l4.027,11.1h3.984l-4.027-11.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_14",
    "data-name": "\\u8DEF\\u5F84 14",
    d: "M1925.206,557.708h3.974l4.214-11.815h-3.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_15",
    "data-name": "\\u8DEF\\u5F84 15",
    d: "M1950.848,545.893l4.214,11.815h3.973l-4.273-11.815Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_16",
    "data-name": "\\u8DEF\\u5F84 16",
    d: "M1991.993,540.47h3.743v-7.11h7.53v-3.478h-7.53v-6.091h-3.743v6.091h-7.032v3.478h7.032Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_17",
    "data-name": "\\u8DEF\\u5F84 17",
    d: "M1985.859,524.766l1.174,4.367h3.414l-.786-4.377h-3.744Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_18",
    "data-name": "\\u8DEF\\u5F84 18",
    d: "M1997.592,529.133h3.278l1.31-4.367-.059-.011h-3.743Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_19",
    "data-name": "\\u8DEF\\u5F84 19",
    d: "M1985.96,540.456h3.663l.888-6.239h-3.345l-1.318,6.223Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_20",
    "data-name": "\\u8DEF\\u5F84 20",
    d: "M1998.378,540.456h3.663l.112-.016-1.417-6.223h-3.246Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_21",
    "data-name": "\\u8DEF\\u5F84 21",
    d: "M2002.266,546.444c.005-.035,0-.072.008-.107h1.366v-3.478h-12.3v-1.451H1987.6v1.451h-2.374v3.478h2.374v4.329l4.075,2.8.125.086-6.084,4.158h6.387l2.882-1.969,2.867,1.969h6.615l-6.214-4.265A11.34,11.34,0,0,0,2002.266,546.444Zm-7.273,4.757-3.648-2.5v-2.36h7.377c-.009.035-.011.072-.02.107a7.655,7.655,0,0,1-3.134,4.532l-.452.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_22",
    "data-name": "\\u8DEF\\u5F84 22",
    d: "M2008.688,524.031h-3.944v15.408a18.286,18.286,0,0,0,3.329,9.579l.979,1.364-4.492,7.326h4.4l2.47-4.029,2.893,4.029h4.615l-5.385-7.492,1.7-2.766a15.493,15.493,0,0,0,2.289-8.112v-9.367h1.938v-3.478h-10.783Zm5.1,5.94v9.367a11.724,11.724,0,0,1-1.738,6.153l-.872,1.424-.064-.086a12.8,12.8,0,0,1-2.428-7.524v-9.334Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_23",
    "data-name": "\\u8DEF\\u5F84 23",
    d: "M2061.637,526.068l-1.067-3.027c-4.222,1.49-7.615,1.486-14.97,1.49h-.328v3.211h.641c1.962,0,3.661,0,5.2-.037v3.336h-6.119v3.585h6.119v23.083h3.743V534.626h6.654v-3.585h-6.654v-3.526A26.579,26.579,0,0,0,2061.637,526.068Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_24",
    "data-name": "\\u8DEF\\u5F84 24",
    d: "M2044.875,557.708h3.55a172.372,172.372,0,0,0,.786-20.54h-3.528C2045.683,545.783,2045.624,551.431,2044.875,557.708Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_25",
    "data-name": "\\u8DEF\\u5F84 25",
    d: "M2056.845,537.168l.9,20.54h3.576l-.914-20.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_26",
    "data-name": "\\u8DEF\\u5F84 26",
    d: "M2004.533,557.751l.027-.043h-.091Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_27",
    "data-name": "\\u8DEF\\u5F84 27",
    d: "M2077.324,523.827h-3.744v23.848h-10.832v3.585h10.832v6.45h3.744v-6.45h2.959v-3.585h-2.959Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_1",
    "data-name": "\\u77E9\\u5F62 1",
    width: 3.743,
    height: 7.456,
    transform: "translate(2065.661 526.891) rotate(-6.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_2",
    "data-name": "\\u77E9\\u5F62 2",
    width: 3.743,
    height: 7.456,
    transform: "matrix(0.993, -0.12, 0.12, 0.993, 2065.661, 537.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_2",
    "data-name": "\\u7EC4 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_28",
    "data-name": "\\u8DEF\\u5F84 28",
    d: "M2089.921,437.035c-6.6-31.422-33.181-49.535-60.375-49.535H2009.1v24.635h24.516C2056.539,412.135,2078.327,417.225,2089.921,437.035Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_29",
    "data-name": "\\u8DEF\\u5F84 29",
    d: "M2009.1,505.842h7.792c25.8,0,45.254-20.557,45.254-47.817a57.608,57.608,0,0,0-.6-8.539c-1.311,18.114-14.56,31.674-32,31.674H2009.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_30",
    "data-name": "\\u8DEF\\u5F84 30",
    d: "M2090.147,456.452c0-24.748-27.909-36.348-48.341-38.028,16.693,4.768,26,18.614,26,39.6,0,28.92-16.018,47.525-41.692,53h4.5C2064.889,511.023,2090.147,480.446,2090.147,456.452Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_31",
    "data-name": "\\u8DEF\\u5F84 31",
    d: "M1937.551,417.57h18.3a31.693,31.693,0,0,1,31.61,32.887c-.654,17.343-13.814,30.421-30.608,30.421H1935.56v30.07h21.289c33.291,0,59.361-25.518,60.638-59.355a61.758,61.758,0,0,0-61.64-64.093H1907.5v80.282a13.651,13.651,0,1,1-27.3,0v-7.819h-30.051v7.819a43.7,43.7,0,1,0,87.4,0Z",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdLogin);
export default __webpack_public_path__ + "static/media/jd_login.619b8b9f0f11956713aeaee7f36c33a8.svg";
export { ForwardRef as ReactComponent };